/**
 * 배당 표시 형식 변환 — 내부 값(decimal)은 그대로, 표시 문자열만 변환
 * @param {number} odds - decimal 배당값
 * @param {string} format - 'decimal' | 'fractional' | 'american'
 * @returns {string} 표시 문자열
 */
export const formatOdds = (odds, format = 'decimal') => {
  const n = Number(odds);
  if (!n || isNaN(n) || n <= 0) return '-';

  if (format === 'american') {
    if (n >= 2.0) return '+' + Math.round((n - 1) * 100);
    return String(Math.round(-100 / (n - 1)));
  }

  if (format === 'fractional') {
    const decimal = n - 1;
    if (decimal <= 0) return '0/1';
    /** 단순 분수 변환 — 100 기반 약분 */
    const numerator = Math.round(decimal * 100);
    const denominator = 100;
    const gcd = (a, b) => b === 0 ? a : gcd(b, a % b);
    const g = gcd(numerator, denominator);
    return `${numerator / g}/${denominator / g}`;
  }

  /** decimal (기본) */
  return n.toFixed(2);
};

export const toDisplayOddsDecimal = (odds) => {
  const n = Number(odds);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Number(n.toFixed(2));
};

/**
 * delta 표시 형식 — decimal 이외에서는 원본 차이 그대로 표시
 */
export const formatDelta = (delta, format = 'decimal') => {
  return Number(delta).toFixed(2);
};
